import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-other-apps',
    templateUrl: './other-apps.component.html',
    styleUrls: ['./other-apps.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtherAppsComponent implements OnInit {

  @Input('menu') menu:any;
  constructor() { }

  shipping:boolean = true;
  inco:boolean = true;
  ContainerVessel:boolean = true;
  freight:boolean = true;
  emission:boolean = true;
  specification:boolean = true;
  ngOnInit(): void {

    this.shipping = true;
    this.inco = true;
    this.ContainerVessel = true;
    this.freight = true;
    this.emission = true;
    this.specification = true;
    switch (this.menu) {
      case 'emission':
        this.emission = false
        break;
        case 'inco':
          this.inco = false
          break;
          case 'ContainerVessel':
            this.ContainerVessel = false
            break;
            case 'freight':
              this.freight = false
              break;
              case 'shipping':
                this.shipping = false
                break;
                case 'specification':
                  this.specification = false
                  break;
                                
      default:
        break;
    }

  }

}
